import axios from 'axios';
import moment from 'moment';

export default async function getJourFerie(annee) {
  try {
    const response = (await axios.get(`https://calendrier.api.gouv.fr/jours-feries/metropole/${annee}.json`)).data;
    const result = Object.keys(response).map((key) => (
      {
        date: moment(key, 'YYYY-MM-DD'),
        nom_jour_ferie: response[key],
      }
    ));
    return result;
  } catch (e) {
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/api/jourFerie/index.js